<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>Essential Links</h2>
    <b-btn v-b-modal.modal1>Launch demo modal</b-btn>

    <!-- Modal Component -->
    <b-modal id="modal1" title="Bootstrap-Vue" @hidden="stopYoutube">
      <p class="my-4">Youtube trailer</p>
      <youtube :video-id="youtubeURL" player-width="100%" style="width:100%" @ready="ready"></youtube>
    </b-modal>
    {{movieDetails}}
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";

export default {
  name: "movieDetails",
  components: { Slick },
  metaInfo: {
    title: "perfect",
    titleTemplate: null
  },
  data() {
    return {
      msg: "Welcome to Your HOMEPAGE",
      slickOptions: {
        slidesToShow: 3
      },
      shows: {},
      youtubeURL: "i4K3os977h4",
      movieDetails: {}
    };
  },
  beforeMount() {
    this.fetchMovieDetails();
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    fetchMovieDetails() {
      let token = null;
      let payload = {
        MovieID: this.$route.params.movieID
      };
      if (this.$persistStore.get("accessToken")) {
        token = this.$persistStore.get("accessToken");
        payload["access_token"] = token;
      }
      console.log("payload", payload);
      makeRequestDirect("/api/GetMovieDetails", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          console.log("data movie", res, error);
          if (!error && res.data) {
            if (!error) {
              this.movieDetails = res.data;
              this.movieDetails["url"] =
                "/movie-showtimes-page?movieId=" + this.movieDetails.ID;
              this.movieDetails.IMDBRating = this.movieDetails.IMDBRating.split(
                "/"
              )[0];
              this.movieDetails.IMDBRating = Math.round(
                parseFloat(this.movieDetails.IMDBRating)
              );
              if (this.movieDetails.Trailers && this.movieDetails.Trailers[0]) {
                this.youtube =
                  "https://www.youtube.com/embed/" +
                  this.movieDetails.Trailers[0].URI;
              }
              this.userRatingDetails.user = this.movieDetails.YourRating;
              console.log("y", this.youtube);
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    stopYoutube: function() {
      this.player.stopVideo();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/movieDetails.vue